import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NewYearGreeting from "./pages/NewYearGreeting";
import Brochure from "./pages/Brochure";
import Trading from "./pages/Trading";
import Contracting from "./pages/Contracting";
import NotFound from "./pages/NotFound";
import EmailTest from "./pages/EmailTest";
import QuoteConfirmation from "./pages/QuoteConfirmation";
import InstagramRedirect from "./pages/InstagramRedirect";
import FacebookRedirect from "./pages/FacebookRedirect";
import AdminAuth from "./pages/AdminAuth";
import AdminQrScans from "./pages/AdminQrScans";
import AdminSecurity from "./pages/AdminSecurity";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import QualityStandards from "./pages/QualityStandards";
import Watermark from "./components/Watermark";
import StickyWhatsApp from "./components/StickyWhatsApp";
import FloatingContactWidget from "./components/FloatingContactWidget";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Watermark />
        <StickyWhatsApp />
        <FloatingContactWidget />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/new-year" element={<NewYearGreeting />} />
        <Route path="/brochure" element={<Brochure />} />
          <Route path="/services/trading" element={<Trading />} />
          <Route path="/services/contracting" element={<Contracting />} />
          <Route path="/quote-confirmation" element={<QuoteConfirmation />} />
          {import.meta.env.DEV && (
            <Route path="/email-test" element={<EmailTest />} />
          )}
          <Route path="/instagram" element={<InstagramRedirect />} />
          <Route path="/facebook" element={<FacebookRedirect />} />
          <Route path="/admin" element={<AdminAuth />} />
          <Route path="/admin/qr-scans" element={<AdminQrScans />} />
          <Route path="/admin/security" element={<AdminSecurity />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/quality-standards" element={<QualityStandards />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
